// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"eb39a9730d5e9a1e","9777":"39ae5378ee59c1ac"}[chunkId] + ".js";
};